<nav mat-tab-nav-bar *lohiFeatureFlag="'migrationMapNavBar'" lohiPageTitle="Owner Dashboard">
  <a
    mat-tab-link
    [routerLink]="['owner-dashboard']"
    routerLinkActive
    #ownerDashboard="routerLinkActive"
    [active]="ownerDashboard.isActive"
  >
    Dashboard
  </a>
  <ng-container *lohiIsNotOnlyFiveFTourOwner>
    <a
      mat-tab-link
      [routerLink]="['driver-information']"
      routerLinkActive
      #driverInfo="routerLinkActive"
      [active]="driverInfo.isActive"
    >
      Your Drivers
    </a>
    <a
      mat-tab-link
      [routerLink]="['news-feed']"
      routerLinkActive
      #newsFeed="routerLinkActive"
      [active]="newsFeed.isActive"
    >
      Regional News
    </a>
  </ng-container>
</nav>
<router-outlet></router-outlet>
